import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import socialProjectData from './data';

const SocialProject = () => {
  return <ProjectDetailView data={socialProjectData} />;
};

export default SocialProject;
